import { memo } from 'react';

import { TEditorConfig } from 'com/Editor/Editor/interface';
import { FormGroup, FormInput } from 'core/ui/Form';

const TestEditorForm: TEditorConfig<null, TTest, TTestUpdate>['Form'] = ({
  editingEntity: editingTest,
  onChange,
}) => {
  return (
    <FormGroup title="Definition">
      <FormInput
        placeholder="Name"
        name="name"
        value={editingTest.name}
        onChange={onChange}
        autoFocus
      />
    </FormGroup>
  );
};

export default memo(TestEditorForm);
